import createAsyncSlice from "../utils/createAsyncSlice";

const informations = createAsyncSlice({
  name: "informations",
  initialState: {
    data: [],
  },
});

export const fetchInformations = informations.asyncAction;
export const { resetState: resetInformationsState } = informations.actions;
export default informations.reducer;
